import { useEffect, useMemo, useState } from 'react';
import { LegacyDeal } from 'src/interfaces/api/Deal';
import useDeal from 'src/hooks/api/useDeal';

export default (limit: number, domainId?: number) => {
  const [deals, setDeals] = useState<LegacyDeal[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const [total, setTotal] = useState(0);
  const { search } = useDeal();

  const criteria = useMemo(() => {
    const criteria = {
      lost: false,
      standBy: false,
      creatorId: -1,
      typeId: -1,
      stepDeal: 2,
      stepIntermediate: 3,
    };

    if (domainId) {
      criteria['domainId'] = domainId;
    }

    return criteria;
  }, [domainId]);

  useEffect(() => {
    setLoading(true);
    search(criteria, 0, limit, 'dateLastStep', 'desc')
      .then((deals) => {
        setDeals(deals);
        setTotal(deals.length);

        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, [limit, criteria]);

  return { error, loading, total, deals };
};
